import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { NotificationType } from "store/type";
import { BrowserRouter as Router } from "react-router-dom";
import { requestUser } from "services/auth.service";
import "./App.scss";
import Route from "./route";
import { setDefaultLanguage, updateTitleNotification } from "./utils";
import { useAppDispatch, useAppSelector } from "common/hooks/redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import NftPreviewModal from "common/components/Modals/NftPreviewModal";
import NetworkModal from "common/components/Modals/NetworkModal";
import CollectionPreviewModal from "common/components/Modals/CollectionPreviewModal";
import { WagmiProvider } from "wagmi";
import { config } from "./config";
import { RootState } from "store/index";
import { SERVER_BASE_URL } from "common/constants";
import { getUserNotificationsList } from "services/createUser.service";
import io from "socket.io-client";
const queryClient = new QueryClient();


const App = (): React.ReactElement => {
	const dispatch = useAppDispatch();
	const { notifications, getNotificationsLoading } = useAppSelector(
		(state: RootState) => state.global
	);
	const { user } = useAppSelector((state: RootState) => state.auth);
	const [localNotifications, setLocalNotifications] =
		useState<NotificationType[]>(notifications);

	const socket = io(SERVER_BASE_URL, {
		query: { userId: user?.id },
	});

	const initialize = (): void => {
		setDefaultLanguage();
	};

	useEffect(() => {
		initialize();
		dispatch(requestUser());
	}, []);

	useEffect(() => {
		if (user?.id) {
			dispatch(getUserNotificationsList({}));
		}
	}, [user, dispatch]);

	useEffect(() => {
		const unreadCount = localNotifications.filter((notif) => !notif.is_read).length;
		updateTitleNotification(unreadCount); // Update title with unread count
	}, [localNotifications]);

	useEffect(() => {
		setLocalNotifications(notifications);
	}, [notifications]);

	return (
		<WagmiProvider config={config}>
			<QueryClientProvider client={queryClient}>
				<div id="complycube-mount"></div>
				<Router>
					<Route />
					<NftPreviewModal />
					<CollectionPreviewModal />
					<NetworkModal />
				</Router>
			</QueryClientProvider>
		</WagmiProvider>
	);
};

export default App;
